export const breakpoints = {
  desktop: '(min-width: 1200px)',
  mobile: '(max-width: 895px)',
  tablet: '(min-width: 896px) and (max-width: 1199px)',
};
